function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var DiplomacyConfirmTemplate = require('./diplomacy-confirm.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var DiplomacyConfirmOverlay = /*#__PURE__*/function () {
  function DiplomacyConfirmOverlay(app, mod) {
    _classCallCheck(this, DiplomacyConfirmOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
    this.overlay.clickBackdropToClose = false;
    this.faction = '';
    this.proposal_idx = 0;
  }
  return _createClass(DiplomacyConfirmOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
      return;
    }
  }, {
    key: "updateInstructions",
    value: function updateInstructions() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      try {
        document.querySelector('.diplomacy-confirm-overlay .help').innerHTML = msg;
      } catch (err) {}
    }
  }, {
    key: "render",
    value: function render(faction) {
      var proposal_idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var proposal = this.mod.game.state.diplomacy[proposal_idx];
      this.faction = faction;
      this.overlay.show(DiplomacyConfirmTemplate(this, proposal, proposal_idx, faction));
      // and hide winter
      this.mod.winter_overlay.hide();
      this.attachEvents(faction, proposal_idx);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(faction) {
      var _this = this;
      var proposal_idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (document.querySelector('.accept')) {
        document.querySelector('.accept').onclick = function (e) {
          _this.hide();
          _this.mod.addMove('diplomacy_accept\t' + _this.faction + '\t' + proposal_idx);
          _this.mod.endTurn();
        };
      }
      if (document.querySelector('.reject')) {
        document.querySelector('.reject').onclick = function (e) {
          _this.hide();
          _this.mod.addMove('diplomacy_reject\t' + _this.faction + '\t' + proposal_idx);
          _this.mod.endTurn();
        };
      }
    }
  }]);
}();
module.exports = DiplomacyConfirmOverlay;